import Http from '@/services/httpJobs'

export const getSalarySearchHistoryStats = () => Http.get('/salary-search-histories/stats')
export const getSalarySearchHistoryList = params => Http.get(`/salary-search-histories`, { params })
